import { OptionByIdRequest } from './option-by-id-request';

export class LoadOptionsByIdsRequest {
    configFile: string;
    optionByIdRequests: OptionByIdRequest[];

    constructor( configFile: string, optionByIdRequests: OptionByIdRequest[] ) {
        this.configFile = configFile;
        this.optionByIdRequests = optionByIdRequests;
    }
}
